// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Couleurs dérivées de la palette existante, dédiées au board sondage */
    --sondage-col-todo-bg: var(--gris-foncer);
    --sondage-col-todo-border: var(--kpi-users-fg);
    --sondage-col-done-bg: var(--gris-foncer);
    --sondage-col-done-border: var(--vert-principale);

    --sondage-card-bg: var(--white-principale);
    --sondage-card-border: var(--gris-terciaire-2);
    --sondage-card-shadow: var(--gris-shadow);
    --sondage-card-hover-border: var(--couleur-principale);

    --sondage-badge-vendeur-bg: var(--kpi-users-bg);
    --sondage-badge-vendeur-fg: var(--kpi-users-fg);
    --sondage-badge-article-bg: var(--kpi-articles-bg);
    --sondage-badge-article-fg: var(--kpi-articles-fg);
    --sondage-badge-done-bg: var(--kpi-good-bg);
    --sondage-badge-done-fg: var(--kpi-good-fg);

    --sondage-avatar-bg: var(--couleur-principale);
    --sondage-avatar-done-bg: var(--vert-principale);

    --sondage-text-title: var(--bleu-principale);
}

/* ============================================================
   HEADER
   ============================================================ */

.sondage_page {
    padding: 24px 16px 48px;
}

.sondage_title {
    font-size: var(--font-size-page-title);
    font-weight: var(--font-weight-title);
    color: var(--sondage-text-title);
}

.sondage_subtitle {
    font-size: var(--font-size-detail-meta);
    color: var(--gris-tertiaire-2);
}

.sondage_btn_refresh {
    background: var(--white-principale);
    border: 1px solid var(--gris-secondaire-3);
    border-radius: 8px;
    font-size: var(--font-size-btn);
    padding: 8px 14px;
}

.sondage_btn_refresh:hover {
    background: var(--gris-secondaire-2);
}

/* ============================================================
   BOARD / COLONNES
   ============================================================ */

.sondage_board {
    margin-top: 20px;
    justify-content: center;
}

.sondage_column {
    background: var(--sondage-col-todo-bg);
    border-radius: 14px;
    border-top: 4px solid var(--sondage-col-todo-border);
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 320px;
}

.sondage_column_done {
    border-top-color: var(--sondage-col-done-border);
}

.sondage_column_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
}

.sondage_column_title {
    font-size: var(--font-size-detail-section);
    font-weight: var(--font-weight-title);
    color: var(--sondage-text-title);
    display: flex;
    align-items: center;
}

.sondage_column_count {
    background: var(--white-principale);
    border: 1px solid var(--gris-secondaire-3);
    border-radius: 999px;
    min-width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: var(--font-weight-title);
    color: var(--sondage-text-title);
}

.sondage_column_body {
    padding: 0 14px 14px;
    overflow-y: auto;
    max-height: 70vh;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.sondage_empty {
    text-align: center;
    padding: 40px 16px;
    color: var(--gris-tertiaire-2);
    font-size: 14px;
}

.sondage_empty i {
    font-size: 28px;
    display: block;
    margin-bottom: 8px;
    color: var(--gris-principale);
}

.sondage_empty_inline {
    font-size: 13px;
    color: var(--gris-tertiaire-2);
    font-style: italic;
    margin: 4px 0 12px;
}

/* ============================================================
   CARTE
   ============================================================ */

.sondage_card {
    background: var(--sondage-card-bg);
    border: 1px solid var(--sondage-card-border);
    border-radius: 12px;
    padding: 12px 14px;
    box-shadow: 0 1px 2px var(--sondage-card-shadow);
    cursor: pointer;
    transition: border-color 0.15s ease, transform 0.15s ease;
}

.sondage_card:hover {
    border-color: var(--sondage-card-hover-border);
    transform: translateY(-1px);
}

.sondage_card_top {
    display: flex;
    align-items: center;
    gap: 10px;
}

.sondage_avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--sondage-avatar-bg);
    color: var(--white-principale);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: var(--font-weight-title);
    font-size: 14px;
    flex-shrink: 0;
    overflow: hidden;
}

.sondage_avatar_done {
    background: var(--sondage-avatar-done-bg);
}

.sondage_avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.sondage_avatar span {
    color: var(--white-principale);
    margin-left: 0;
}

.sondage_card_identity {
    min-width: 0;
}

.sondage_card_name {
    font-size: var(--font-size-article-title);
    font-weight: var(--font-weight-title);
    color: var(--sondage-text-title);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sondage_card_meta {
    font-size: var(--font-size-location);
    color: var(--gris-tertiaire-2);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sondage_card_badges {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
}

.sondage_badge {
    font-size: var(--font-size-badge);
    padding: 3px 9px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    font-weight: var(--font-weight-medium);
}

.sondage_badge_vendeur {
    background: var(--sondage-badge-vendeur-bg);
    color: var(--sondage-badge-vendeur-fg);
}

.sondage_badge_article {
    background: var(--sondage-badge-article-bg);
    color: var(--sondage-badge-article-fg);
}

.sondage_badge_done {
    background: var(--sondage-badge-done-bg);
    color: var(--sondage-badge-done-fg);
}

.sondage_card_footer {
    margin-top: 10px;
    font-size: 12px;
    color: var(--gris-tertiaire-2);
    display: flex;
    align-items: center;
}

/* ============================================================
   MODAL (ancien overlay — conservé si utilisé ailleurs)
   ============================================================ */

.sondage_modal_overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    z-index: 1050;
}

.sondage_modal {
    background: var(--white-principale);
    border-radius: 14px;
    width: 100%;
    max-width: 640px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.sondage_modal_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--gris-secondaire-3);
}

.sondage_modal_name {
    font-size: var(--font-size-detail-section);
    font-weight: var(--font-weight-title);
    color: var(--sondage-text-title);
}

.sondage_modal_close {
    background: none;
    border: none;
    font-size: 18px;
    color: var(--gris-tertiaire-2);
    cursor: pointer;
}

.sondage_modal_body {
    padding: 18px 20px;
    overflow-y: auto;
    flex: 1 1;
}

.sondage_modal_footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 14px 20px;
    border-top: 1px solid var(--gris-secondaire-3);
}

/* ============================================================
   SECTIONS / QUESTIONS-REPONSES (ancien layout — conservé)
   ============================================================ */

.sondage_section {
    margin-bottom: 20px;
}

.sondage_section_title {
    font-size: var(--font-size-detail-section);
    font-weight: var(--font-weight-title);
    color: var(--sondage-text-title);
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.sondage_qa {
    padding: 8px 0;
    border-bottom: 1px dashed var(--gris-secondaire-3);
}

.sondage_qa:last-child {
    border-bottom: none;
}

.sondage_qa_question {
    font-size: 13px;
    color: var(--gris-tertiaire-2);
    margin-bottom: 2px;
}

.sondage_qa_reponse {
    font-size: var(--font-size-detail-text);
    color: var(--sondage-text-title);
    font-weight: var(--font-weight-medium);
}

.sondage_form_group {
    margin-bottom: 14px;
}

.sondage_form_label {
    font-size: 13px;
    font-weight: var(--font-weight-medium);
    color: var(--sondage-text-title);
    margin-bottom: 6px;
}

.sondage_article_block {
    border: 1px solid var(--gris-secondaire-3);
    border-radius: 10px;
    padding: 10px 14px;
    margin-bottom: 12px;
    background: var(--gris-foncer);
}

.sondage_article_block_todo {
    border-color: var(--kpi-signal-fg);
    background: var(--kpi-signal-bg);
}

.sondage_article_summary {
    font-size: var(--font-size-article-title);
    font-weight: var(--font-weight-title);
    color: var(--sondage-text-title);
    cursor: pointer;
    display: flex;
    align-items: center;
}

.sondage_article_block[open] .sondage_article_summary {
    margin-bottom: 10px;
}

/* ============================================================
   VARIABLES DEDIEES (dérivées de la palette principale)
   ============================================================ */

:root {
    --sondage-accent: var(--couleur-principale);
    --sondage-accent-soft: rgba(11, 0, 207, 0.06);
    --sondage-accent-soft-strong: rgba(11, 0, 207, 0.1);

    --sondage-attention: var(--couleur-secondaire);
    --sondage-attention-soft: rgba(255, 45, 43, 0.06);
    --sondage-attention-soft-strong: rgba(255, 45, 43, 0.1);

    --sondage-success: var(--vert-principale);
    --sondage-success-soft: rgba(37, 183, 154, 0.08);
    --sondage-success-soft-strong: rgba(37, 183, 154, 0.14);

    /* --- NOUVEAU : bouton fermer, progression, scrollbar --- */
    --sondage-close-bg: var(--white-principale);
    --sondage-close-bg-hover: var(--gris-secondaire-2);
    --sondage-close-fg: var(--sondage-text-title);

    --sondage-progress-track: rgba(255, 255, 255, 0.18);
    --sondage-progress-fill: var(--white-principale);

    --sondage-scrollbar-thumb: var(--gris-secondaire-3);
    --sondage-scrollbar-thumb-hover: var(--gris-principale);
    --sondage-scrollbar-track: transparent;
}

/* ============================================================
   STRUCTURE PLEIN ECRAN
   ============================================================ */

.sondage_modal_fullscreen {
    position: fixed;
    inset: 0;
    z-index: 1055;
    display: flex;
    background: var(--white-principale);
    animation: sondageModalIn 0.18s ease-out;
}

@keyframes sondageModalIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* ---- Bouton fermer (X) — toujours visible, desktop + mobile ---- */

.sondage_modal_close_x {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 20;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    border: none;
    background: var(--sondage-close-bg);
    color: var(--sondage-close-fg);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    cursor: pointer;
    box-shadow: 0 2px 10px var(--gris-shadow);
    transition: background 0.15s ease, transform 0.15s ease;
}

.sondage_modal_close_x:hover {
    background: var(--sondage-close-bg-hover);
    transform: scale(1.06);
}

.sondage_modal_close_x:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ---- Sidebar ---- */

.sondage_modal_sidebar {
    width: 300px;
    flex-shrink: 0;
    background: linear-gradient(165deg,
            var(--couleur-principale) 0%,
            var(--violet-principale) 130%);
    color: var(--white-principale);
    display: flex;
    flex-direction: column;
    padding: 32px 22px 22px;
    overflow-y: auto;
}

.sondage_sidebar_user {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-bottom: 24px;
    margin-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.18);
}

.sondage_avatar_xl {
    width: 76px;
    height: 76px;
    font-size: 24px;
    background: rgba(255, 255, 255, 0.15);
    border: 2px solid rgba(255, 255, 255, 0.4);
    margin-bottom: 14px;
}

.sondage_sidebar_name {
    font-size: 17px;
    font-weight: var(--font-weight-title);
}

.sondage_sidebar_email {
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.75);
    margin-top: 2px;
    word-break: break-word;
}

.sondage_sidebar_phone {
    font-size: 15px;
    color: var(--white-principale);
    margin-top: 2px;
    word-break: break-word;
}

.sondage_sidebar_remaining {
    margin-top: 14px;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 999px;
    padding: 5px 14px;
    font-size: 12px;
    font-weight: var(--font-weight-medium);
    color: var(--white-principale);
}

/* ---- Barre de progression ---- */

.sondage_sidebar_progress_track {
    width: 100%;
    height: 6px;
    border-radius: 999px;
    background: var(--sondage-progress-track);
    margin-top: 14px;
    overflow: hidden;
}

.sondage_sidebar_progress_fill {
    height: 100%;
    border-radius: 999px;
    background: var(--sondage-progress-fill);
    transition: width 0.25s ease;
}

.sondage_sidebar_progress_label {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.75);
    margin-top: 6px;
}

.sondage_sidebar_steps {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1;
    margin-top: 20px;
}

.sondage_step {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.85);
    text-decoration: none;
    font-size: 13.5px;
    font-weight: var(--font-weight-medium);
    transition: background 0.15s ease;
}

.sondage_step:hover {
    background: rgba(255, 255, 255, 0.12);
    color: var(--white-principale);
}

.sondage_step_label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--white-principale);
}

.sondage_step_dot {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.55);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
}

/* .sondage_step_dot i {
  color: #fff;
} */

.sondage_step_done .sondage_step_dot {
    background: var(--white-principale);
    color: var(--sondage-accent);
    border-color: var(--white-principale);
}

.sondage_step_todo .sondage_step_dot {
    border-color: var(--white-principale);
}

.sondage_sidebar_close {
    margin-top: 20px;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.35);
    color: var(--white-principale);
    border-radius: 10px;
    padding: 10px 14px;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.15s ease;
}

.sondage_sidebar_close:hover {
    background: rgba(255, 255, 255, 0.14);
}

.sondage_sidebar_close:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ---- Zone principale ---- */
/* FIX SCROLL : min-height:0 est obligatoire sur les enfants flex
   dont on veut que overflow-y:auto fonctionne réellement */

.sondage_modal_main {
    flex: 1 1;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: var(--gris-foncer);
    padding-bottom: 50px;
}

.sondage_modal_content {
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    justify-content: center;
    padding: 40px 24px 48px;
}

/* Scrollbar stylée (Chrome / Edge / Safari) */
.sondage_modal_content::-webkit-scrollbar,
.sondage_modal_sidebar::-webkit-scrollbar {
    width: 8px;
}

.sondage_modal_content::-webkit-scrollbar-track,
.sondage_modal_sidebar::-webkit-scrollbar-track {
    background: var(--sondage-scrollbar-track);
}

.sondage_modal_content::-webkit-scrollbar-thumb {
    background: var(--sondage-scrollbar-thumb);
    border-radius: 999px;
}

.sondage_modal_content::-webkit-scrollbar-thumb:hover {
    background: var(--sondage-scrollbar-thumb-hover);
}

.sondage_modal_sidebar::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 999px;
}

.sondage_modal_sections {
    width: 90%;
    /* max-width: 720px; */
    display: flex;
    flex-direction: column;
    gap: 22px;
    scroll-behavior: smooth;
}

/* ============================================================
   CARTES DE FORMULAIRE
   ============================================================ */

.sondage_form_card {
    background: var(--white-principale);
    border-radius: 16px;
    border: 1px solid var(--gris-secondaire-3);
    box-shadow: 0 2px 10px var(--gris-shadow);
    scroll-margin-top: 24px;
    /* overflow: hidden; */
}

.sondage_form_card_header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 18px 22px;
}

.sondage_form_card_header i {
    font-size: 20px;
    width: 42px;
    height: 42px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.sondage_form_card_header h6 {
    margin: 0;
    font-size: 15.5px;
    font-weight: var(--font-weight-title);
    color: var(--sondage-text-title);
}

.sondage_form_card_header span {
    font-size: 12.5px;
    color: var(--gris-tertiaire-2);
}

.sondage_form_card_todo .sondage_form_card_header {
    background: var(--sondage-attention-soft);
}

.sondage_form_card_todo .sondage_form_card_header i {
    background: var(--sondage-attention-soft-strong);
    color: var(--sondage-attention);
}

.sondage_form_card_done .sondage_form_card_header {
    background: var(--sondage-success-soft);
}

.sondage_form_card_done .sondage_form_card_header i {
    background: var(--sondage-success-soft-strong);
    color: var(--sondage-success);
}

.sondage_form_card_body {
    padding: 20px 22px 22px;
    display: flex;
    flex-direction: column;
    gap: 18px;
}

/* ============================================================
   CHAMPS
   ============================================================ */

.sondage_field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.sondage_field_label {
    font-size: 13.5px;
    font-weight: var(--font-weight-medium);
    color: var(--sondage-text-title);
}

.sondage_field_input {
    width: 100%;
    border: 1.5px solid var(--gris-secondaire-3);
    border-radius: 10px;
    padding: 11px 14px;
    font-size: 14px;
    font-family: inherit;
    resize: vertical;
    background: var(--white-tertiaire-1);
    transition: border-color 0.15s ease, background 0.15s ease;
}

.sondage_field_input:focus {
    outline: none;
    border-color: var(--sondage-accent);
    background: var(--white-principale);
    box-shadow: 0 0 0 3px var(--sondage-accent-soft);
}

.sondage_field_readonly .sondage_field_label {
    color: var(--gris-tertiaire-2);
    font-weight: var(--font-weight-normal);
}

.sondage_field_value {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    border: 1.5px solid var(--sondage-success-soft-strong);
    background: var(--sondage-success-soft);
    border-radius: 10px;
    padding: 11px 14px;
    font-size: 14px;
    font-weight: var(--font-weight-medium);
    color: var(--sondage-text-title);
}

.sondage_field_value i {
    color: var(--sondage-success);
    margin-top: 2px;
    flex-shrink: 0;
}

/* ---- Choix à puces (pills) ---- */

.sondage_pill_group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.sondage_pill {
    border: 1.5px solid var(--gris-secondaire-3);
    background: var(--white-principale);
    color: var(--sondage-text-title);
    border-radius: 999px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: var(--font-weight-medium);
    cursor: pointer;
    transition: all 0.15s ease;
}

.sondage_pill:hover {
    border-color: var(--sondage-accent);
}

.sondage_pill.active {
    background: var(--sondage-accent);
    border-color: var(--sondage-accent);
    color: var(--white-principale);
}

.sondage_empty_inline {
    font-size: 13px;
    color: var(--gris-tertiaire-2);
    font-style: italic;
    margin: 0;
}

/* ============================================================
   FOOTER
   ============================================================ */

.sondage_modal_footer_fixed {
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 16px 24px;
    background: var(--white-principale);
    border-top: 1px solid var(--gris-secondaire-3);
    flex-shrink: 0;
}

.sondage_btn_secondary {
    background: var(--white-principale);
    border: 1.5px solid var(--gris-secondaire-3);
    color: var(--sondage-text-title);
    border-radius: 10px;
    padding: 9px 18px;
    font-size: var(--font-size-btn);
}

.sondage_btn_primary {
    background: linear-gradient(120deg,
            var(--couleur-principale),
            var(--violet-principale));
    color: var(--white-principale);
    border: none;
    border-radius: 10px;
    padding: 9px 20px;
    font-size: var(--font-size-btn);
    font-weight: var(--font-weight-medium);
    box-shadow: 0 4px 14px var(--sondage-accent-soft-strong);
}

.sondage_btn_primary:disabled,
.sondage_btn_secondary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
}

/* ---- Item sidebar "Tout afficher" + état actif ---- */

.sondage_step_all {
    font-weight: var(--font-weight-title);
    margin-bottom: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.14);
    padding-bottom: 12px;
}

.sondage_step.active {
    background: rgba(255, 255, 255, 0.22);
    color: var(--white-principale);
}

/* ---- Footer de section (bouton individuel) ---- */

.sondage_form_card_footer {
    display: flex;
    justify-content: flex-end;
    padding: 4px 22px 22px;
}

.sondage_btn_primary_sm {
    background: var(--sondage-accent);
    color: var(--white-principale);
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: var(--font-weight-medium);
    cursor: pointer;
    transition: opacity 0.15s ease, transform 0.15s ease;
}

.sondage_btn_primary_sm:hover:not(:disabled) {
    transform: translateY(-1px);
}

.sondage_btn_primary_sm:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ============================================================
   REMARQUE
   ============================================================ */

.sondage_remarque_block {
    border-top: 1px dashed var(--gris-secondaire-3);
    padding-top: 16px;
    margin-top: 4px;
}

.sondage_remarque_label {
    font-size: 13.5px;
    font-weight: var(--font-weight-medium);
    color: var(--sondage-text-title);
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.sondage_remarque_label i {
    color: var(--sondage-attention);
}

.sondage_field_value_remarque {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    border: 1.5px dashed var(--gris-secondaire-3);
    background: var(--gris-foncer);
    border-radius: 10px;
    padding: 11px 14px;
    font-size: 13.5px;
    color: var(--gris-tertiaire-2);
    font-style: italic;
}

.sondage_field_value_remarque i {
    color: var(--sondage-attention);
    margin-top: 2px;
    flex-shrink: 0;
}

/* ============================================================
   QUESTIONS IMPREVUES
   ============================================================ */

.sondage_extra_questions {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 4px;
}

.sondage_extra_question {
    border: 1.5px dashed var(--sondage-accent-soft-strong);
    background: var(--sondage-accent-soft);
    border-radius: 10px;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.sondage_extra_question_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.sondage_extra_question_tag {
    font-size: 11px;
    font-weight: var(--font-weight-medium);
    color: var(--sondage-accent);
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.sondage_extra_remove_btn {
    background: none;
    border: none;
    color: var(--sondage-attention);
    font-size: 15px;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 6px;
    line-height: 1;
    transition: background 0.15s ease;
}

.sondage_extra_remove_btn:hover {
    background: var(--sondage-attention-soft-strong);
}

.sondage_extra_question_input {
    border: 1.5px solid var(--gris-secondaire-3);
    border-radius: 8px;
    padding: 9px 12px;
    font-size: 13.5px;
    font-family: inherit;
    background: var(--white-principale);
    transition: border-color 0.15s ease;
}

.sondage_extra_question_input:focus {
    outline: none;
    border-color: var(--sondage-accent);
    box-shadow: 0 0 0 3px var(--sondage-accent-soft);
}

.sondage_btn_add_question {
    align-self: flex-start;
    background: transparent;
    border: 1.5px dashed var(--gris-secondaire-3);
    color: var(--sondage-accent);
    border-radius: 8px;
    padding: 8px 14px;
    font-size: 13px;
    font-weight: var(--font-weight-medium);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: border-color 0.15s ease, background 0.15s ease;
}

.sondage_btn_add_question:hover {
    border-color: var(--sondage-accent);
    background: var(--sondage-accent-soft);
}

@media (max-width: 575px) {
    .sondage_form_card_footer {
        padding: 4px 16px 16px;
    }
}

.sondage_btn_export {
    background: var(--sondage-badge-done-bg);
    color: var(--sondage-badge-done-fg);
    border: 1px solid var(--sondage-col-done-border);
    border-radius: 8px;
    font-size: var(--font-size-btn);
    padding: 8px 14px;
    font-weight: var(--font-weight-medium);
    transition: background 0.15s ease;
}

.sondage_btn_export:hover:not(:disabled) {
    background: var(--sondage-success-soft-strong);
}

.sondage_btn_export:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ============================================================
   RECHERCHE
   ============================================================ */

.sondage_search_wrap {
    margin-top: 16px;
}

.sondage_search_box {
    position: relative;
    max-width: 420px;
    display: flex;
    align-items: center;
}

.sondage_search_icon {
    position: absolute;
    left: 14px;
    color: var(--gris-tertiaire-2);
    font-size: 14px;
    pointer-events: none;
}

.sondage_search_input {
    width: 100%;
    border: 1.5px solid var(--gris-secondaire-3);
    border-radius: 10px;
    padding: 10px 40px 10px 38px;
    font-size: 14px;
    font-family: inherit;
    background: var(--white-principale);
    color: var(--sondage-text-title);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.sondage_search_input:focus {
    outline: none;
    border-color: var(--sondage-accent);
    box-shadow: 0 0 0 3px var(--sondage-accent-soft);
}

.sondage_search_input::placeholder {
    color: var(--gris-tertiaire-2);
}

.sondage_search_clear {
    position: absolute;
    right: 10px;
    background: none;
    border: none;
    color: var(--gris-tertiaire-2);
    font-size: 12px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 50%;
    transition: background 0.15s ease;
}

.sondage_search_clear:hover {
    background: var(--gris-secondaire-2);
    color: var(--sondage-text-title);
}

/* ============================================================
   SELECTION GROUPEE (bulk)
   ============================================================ */

.sondage_step_bulk_toggle {
    background: rgba(255, 255, 255, 0.1);
    border: 1px dashed rgba(255, 255, 255, 0.4);
    cursor: pointer;
    width: 100%;
    text-align: left;
    margin-bottom: 2px;
    font-family: inherit;
}

.sondage_step_bulk_toggle:hover {
    background: rgba(255, 255, 255, 0.16);
}

.sondage_step_bulk_toggle.active {
    background: rgba(255, 255, 255, 0.22);
    border-style: solid;
}

.sondage_bulk_select_all {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;
    text-decoration: underline;
    padding: 2px 12px 12px;
    cursor: pointer;
    align-self: flex-start;
}

.sondage_bulk_select_all:hover {
    color: var(--white-principale);
}

.sondage_step_checkable {
    cursor: pointer;
}

.sondage_step_checkbox {
    width: 16px;
    height: 16px;
    accent-color: var(--white-principale);
    flex-shrink: 0;
    cursor: pointer;
    margin: 0;
}

.sondage_step_checkable.checked {
    background: rgba(255, 255, 255, 0.18);
}

.sondage_bulk_bar {
    position: sticky;
    top: 0;
    z-index: 5;
    background: var(--white-principale);
    border: 1.5px solid var(--sondage-accent);
    border-radius: 16px;
    box-shadow: 0 4px 18px var(--sondage-card-shadow);
    padding: 18px 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.sondage_bulk_bar_title {
    font-size: 13.5px;
    font-weight: var(--font-weight-title);
    color: var(--sondage-accent);
    display: flex;
    align-items: center;
    gap: 8px;
}

.sondage_step_done .sondage_step_dot {
    background: var(--sondage-success);
    color: var(--white-principale);
    border-color: var(--sondage-success);
}

.sondage_step_done .sondage_step_dot i {
    font-size: 12px;
    font-weight: bold;
}

.sondage_step_todo .sondage_step_dot {
    background: transparent;
    border-color: rgba(255, 255, 255, 0.5);
}

/* Léger contraste de fond pour bien distinguer les lignes "faites" */
.sondage_step_done {
    color: rgba(255, 255, 255, 0.95);
}

.sondage_step_done .sondage_step_label {
    opacity: 0.9;
}

.sondage_sidebar_legend {
    display: flex;
    gap: 14px;
    font-size: 11.5px;
    color: rgba(255, 255, 255, 0.75);
    margin-top: 8px;
}

.sondage_sidebar_legend span {
    color: var(--white-principale);
}

.sondage_legend_dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
}

.sondage_legend_dot.done {
    background: var(--sondage-success);
}

.sondage_legend_dot.todo {
    border: 1.5px solid rgba(255, 255, 255, 0.6);
}

@media (max-width: 900px) {
    .sondage_step_checkable {
        flex-shrink: 0;
    }
}

@media (max-width: 575px) {
    .sondage_search_box {
        max-width: 100%;
    }
}


/* ============================================================
   HEADER — positionnement pour bouton Modifier
   ============================================================ */
.sondage_form_card_header {
    display: flex;
    align-items: center;
    gap: 10px;
}

.sondage_form_card_header>div:not(.sondage_edit_actions) {
    flex: 1 1;
}

/* ============================================================
   BOUTON MODIFIER
   ============================================================ */
.sondage_btn_edit {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    font-size: 0.82rem;
    font-weight: 500;
    color: #0B00CF;
    background-color: transparent;
    border: none;
    /* border-radius: 8px; */
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.15s ease, transform 0.1s ease;
}

.sondage_btn_edit:hover {
    background-color: #E4E1FF;
}

.sondage_btn_edit:active {
    transform: scale(0.97);
}

.sondage_btn_edit i {
    font-size: 0.78rem;
}

/* ============================================================
   ACTIONS EN MODE EDITION (Enregistrer / Annuler)
   ============================================================ */
.sondage_edit_actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.sondage_btn_secondary_sm {
    padding: 6px 14px;
    font-size: 0.82rem;
    font-weight: 500;
    color: #555;
    background-color: #F2F2F2;
    border: 1px solid #DDD;
    border-radius: 8px;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.15s ease;
}

.sondage_btn_secondary_sm:hover:not(:disabled) {
    background-color: #E6E6E6;
}

.sondage_btn_secondary_sm:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* ============================================================
   TOGGLE MOBILE — bascule entre les 2 colonnes (façon light/dark)
   ============================================================ */

.sondage_mobile_switch {
    display: none;
}

@media (max-width: 991px) {
    .sondage_mobile_switch {
        display: flex;
        align-items: center;
        gap: 2px;
        margin-top: 14px;
        padding: 4px;
        background: var(--gris-foncer);
        border: 1px solid var(--gris-secondaire-3);
        border-radius: 999px;
        max-width: 420px;
        margin-bottom: 10px;
    }

    .sondage_mobile_switch_btn {
        flex: 1 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        border: none;
        background: transparent;
        color: var(--gris-tertiaire-2);
        font-size: 13px;
        font-weight: var(--font-weight-medium);
        padding: 9px 10px;
        border-radius: 999px;
        cursor: pointer;
        transition: background 0.18s ease, color 0.18s ease;
    }

    .sondage_mobile_switch_btn.active {
        background: var(--sondage-accent);
        color: var(--white-principale);
        box-shadow: 0 2px 8px var(--sondage-accent-soft-strong);
    }

    .sondage_mobile_switch_count {
        font-size: 11px;
        font-weight: 700;
        background: rgba(255, 255, 255, 0.25);
        border-radius: 999px;
        min-width: 18px;
        padding: 1px 6px;
        line-height: 1.4;
    }

    .sondage_mobile_switch_btn:not(.active) .sondage_mobile_switch_count {
        background: var(--white-principale);
        color: var(--sondage-text-title);
        border: 1px solid var(--gris-secondaire-3);
    }

    .sondage_col_hide_mobile {
        display: none !important;
    }
}


@media (max-width: 576px) {
    .sondage_form_card_header {
        flex-wrap: wrap;
    }

    .sondage_btn_edit,
    .sondage_edit_actions {
        margin-left: auto;
    }
}

/* ============================================================
   RESPONSIVE
   ============================================================ */

@media (max-width: 900px) {
    .sondage_modal_fullscreen {
        flex-direction: column;
    }

    .sondage_modal_sidebar {
        width: 100%;
        flex-direction: row;
        align-items: center;
        padding: 16px 60px 16px 18px;
        /* espace réservé au bouton X */
        gap: 16px;
        overflow-x: auto;
        overflow-y: visible;
        flex-shrink: 0;
    }

    .sondage_sidebar_user {
        flex-direction: row;
        text-align: left;
        border-bottom: none;
        border-right: 1px solid rgba(255, 255, 255, 0.18);
        padding-bottom: 0;
        margin-bottom: 0;
        padding-right: 16px;
        gap: 12px;
        flex-shrink: 0;
    }

    .sondage_avatar_xl {
        width: 48px;
        height: 48px;
        font-size: 16px;
        margin-bottom: 0;
    }

    .sondage_sidebar_progress_track,
    .sondage_sidebar_progress_label {
        display: none;
    }

    .sondage_sidebar_remaining {
        margin-top: 4px;
    }

    .sondage_sidebar_steps {
        flex-direction: row;
        overflow-x: auto;
        margin-top: 0;
    }

    .sondage_step_label {
        max-width: 110px;
    }

    .sondage_sidebar_close {
        display: none;
    }

    .sondage_modal_content {
        padding: 24px 16px 32px;
    }
}

@media (max-width: 575px) {
    .sondage_page {
        padding: 16px 10px 32px;
    }

    .sondage_modal {
        max-height: 95vh;
    }

    .sondage_card_name {
        max-width: 160px;
    }

    .sondage_form_card_header {
        padding: 14px 16px;
    }

    .sondage_form_card_body {
        padding: 16px;
    }

    .sondage_modal_footer_fixed {
        padding: 12px 16px;
    }

    .sondage_modal_close_x {
        top: 12px;
        right: 12px;
        width: 34px;
        height: 34px;
    }
}

@media (max-width: 991px) {
    .sondage_column_body {
        max-height: 70vh;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/sondage/AdminSondageReponse.css"],"names":[],"mappings":"AAAA;IACI,wEAAwE;IACxE,yCAAyC;IACzC,8CAA8C;IAC9C,yCAAyC;IACzC,iDAAiD;;IAEjD,0CAA0C;IAC1C,8CAA8C;IAC9C,yCAAyC;IACzC,sDAAsD;;IAEtD,+CAA+C;IAC/C,+CAA+C;IAC/C,kDAAkD;IAClD,kDAAkD;IAClD,2CAA2C;IAC3C,2CAA2C;;IAE3C,8CAA8C;IAC9C,gDAAgD;;IAEhD,4CAA4C;AAChD;;AAEA;;iEAEiE;;AAEjE;IACI,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;IACnC,0CAA0C;IAC1C,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;iEAEiE;;AAEjE;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,oDAAoD;IACpD,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,0CAA0C;IAC1C,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;iEAEiE;;AAEjE;IACI,kCAAkC;IAClC,4CAA4C;IAC5C,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf,yDAAyD;AAC7D;;AAEA;IACI,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,wCAAwC;IACxC,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;AAEA;;iEAEiE;;AAEjE;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,0CAA0C;IAC1C,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;;iEAEiE;;AAEjE;IACI,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,qCAAqC;IACrC,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;iEAEiE;;AAEjE;IACI,2CAA2C;IAC3C,6CAA6C;IAC7C,mDAAmD;;IAEnD,8CAA8C;IAC9C,iDAAiD;IACjD,uDAAuD;;IAEvD,yCAAyC;IACzC,gDAAgD;IAChD,uDAAuD;;IAEvD,4DAA4D;IAC5D,2CAA2C;IAC3C,kDAAkD;IAClD,6CAA6C;;IAE7C,mDAAmD;IACnD,gDAAgD;;IAEhD,mDAAmD;IACnD,uDAAuD;IACvD,sCAAsC;AAC1C;;AAEA;;iEAEiE;;AAEjE;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,aAAa;IACb,mCAAmC;IACnC,wCAAwC;AAC5C;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,qEAAqE;;AAErE;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mCAAmC;IACnC,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,yCAAyC;IACzC,uDAAuD;AAC3D;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,sBAAsB;;AAEtB;IACI,YAAY;IACZ,cAAc;IACd;;0CAEsC;IACtC,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,0CAA0C;IAC1C,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA,mCAAmC;;AAEnC;IACI,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,wCAAwC;IACxC,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,qBAAqB;IACrB,iBAAiB;IACjB,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;GAEG;;AAEH;IACI,mCAAmC;IACnC,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,2CAA2C;IAC3C,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;2DAC2D;;AAE3D;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA,8CAA8C;AAC9C;;IAEI,UAAU;AACd;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;;iEAEiE;;AAEjE;IACI,mCAAmC;IACnC,mBAAmB;IACnB,0CAA0C;IAC1C,yCAAyC;IACzC,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gDAAgD;IAChD,+BAA+B;AACnC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8CAA8C;IAC9C,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;iEAEiE;;AAEjE;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,oCAAoC;IACpC,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,mCAAmC;IACnC,gDAAgD;AACpD;;AAEA;IACI,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,sDAAsD;IACtD,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;;AAEA,oCAAoC;;AAEpC;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,4CAA4C;IAC5C,mCAAmC;IACnC,gCAAgC;IAChC,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;AACb;;AAEA;;iEAEiE;;AAEjE;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,mCAAmC;IACnC,8CAA8C;IAC9C,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,4CAA4C;IAC5C,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI;;qCAEiC;IACjC,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;IAC/B,sCAAsC;IACtC,wDAAwD;AAC5D;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,wDAAwD;;AAExD;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kDAAkD;IAClD,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA,oDAAoD;;AAEpD;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,eAAe;IACf,oDAAoD;AACxD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;iEAEiE;;AAEjE;IACI,+CAA+C;IAC/C,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,6CAA6C;IAC7C,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,cAAc;AAClB;;AAEA;;iEAEiE;;AAEjE;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,sDAAsD;IACtD,sCAAsC;IACtC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,mCAAmC;IACnC,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6CAA6C;IAC7C,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,0DAA0D;AAC9D;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,wCAAwC;IACxC,mCAAmC;IACnC,gDAAgD;IAChD,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;IACjB,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;iEAEiE;;AAEjE;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,8BAA8B;IAC9B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;IACnB,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;IACpB,mCAAmC;IACnC,gCAAgC;IAChC,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,gDAAgD;AACpD;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;;iEAEiE;;AAEjE;IACI,oCAAoC;IACpC,2CAA2C;IAC3C,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;IACnB,iDAAiD;IACjD,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA,qEAAqE;AACrE;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;;AAGA;;iEAEiE;AACjE;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;;iEAEiE;AACjE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,mBAAmB;IACnB,4DAA4D;AAChE;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;iEAEiE;AACjE;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;iEAEiE;;AAEjE;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,gBAAgB;QAChB,YAAY;QACZ,8BAA8B;QAC9B,0CAA0C;QAC1C,oBAAoB;QACpB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,SAAO;QACP,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,QAAQ;QACR,YAAY;QACZ,uBAAuB;QACvB,8BAA8B;QAC9B,eAAe;QACf,sCAAsC;QACtC,iBAAiB;QACjB,oBAAoB;QACpB,eAAe;QACf,mDAAmD;IACvD;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,uDAAuD;IAC3D;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,qCAAqC;QACrC,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,mCAAmC;QACnC,gCAAgC;QAChC,0CAA0C;IAC9C;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;;iEAEiE;;AAEjE;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,mBAAmB;QACnB,4BAA4B;QAC5B,+BAA+B;QAC/B,SAAS;QACT,gBAAgB;QAChB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;QACnB,iDAAiD;QACjD,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,SAAS;QACT,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[":root {\n    /* Couleurs dérivées de la palette existante, dédiées au board sondage */\n    --sondage-col-todo-bg: var(--gris-foncer);\n    --sondage-col-todo-border: var(--kpi-users-fg);\n    --sondage-col-done-bg: var(--gris-foncer);\n    --sondage-col-done-border: var(--vert-principale);\n\n    --sondage-card-bg: var(--white-principale);\n    --sondage-card-border: var(--gris-terciaire-2);\n    --sondage-card-shadow: var(--gris-shadow);\n    --sondage-card-hover-border: var(--couleur-principale);\n\n    --sondage-badge-vendeur-bg: var(--kpi-users-bg);\n    --sondage-badge-vendeur-fg: var(--kpi-users-fg);\n    --sondage-badge-article-bg: var(--kpi-articles-bg);\n    --sondage-badge-article-fg: var(--kpi-articles-fg);\n    --sondage-badge-done-bg: var(--kpi-good-bg);\n    --sondage-badge-done-fg: var(--kpi-good-fg);\n\n    --sondage-avatar-bg: var(--couleur-principale);\n    --sondage-avatar-done-bg: var(--vert-principale);\n\n    --sondage-text-title: var(--bleu-principale);\n}\n\n/* ============================================================\n   HEADER\n   ============================================================ */\n\n.sondage_page {\n    padding: 24px 16px 48px;\n}\n\n.sondage_title {\n    font-size: var(--font-size-page-title);\n    font-weight: var(--font-weight-title);\n    color: var(--sondage-text-title);\n}\n\n.sondage_subtitle {\n    font-size: var(--font-size-detail-meta);\n    color: var(--gris-tertiaire-2);\n}\n\n.sondage_btn_refresh {\n    background: var(--white-principale);\n    border: 1px solid var(--gris-secondaire-3);\n    border-radius: 8px;\n    font-size: var(--font-size-btn);\n    padding: 8px 14px;\n}\n\n.sondage_btn_refresh:hover {\n    background: var(--gris-secondaire-2);\n}\n\n/* ============================================================\n   BOARD / COLONNES\n   ============================================================ */\n\n.sondage_board {\n    margin-top: 20px;\n    justify-content: center;\n}\n\n.sondage_column {\n    background: var(--sondage-col-todo-bg);\n    border-radius: 14px;\n    border-top: 4px solid var(--sondage-col-todo-border);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    min-height: 320px;\n}\n\n.sondage_column_done {\n    border-top-color: var(--sondage-col-done-border);\n}\n\n.sondage_column_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 18px;\n}\n\n.sondage_column_title {\n    font-size: var(--font-size-detail-section);\n    font-weight: var(--font-weight-title);\n    color: var(--sondage-text-title);\n    display: flex;\n    align-items: center;\n}\n\n.sondage_column_count {\n    background: var(--white-principale);\n    border: 1px solid var(--gris-secondaire-3);\n    border-radius: 999px;\n    min-width: 28px;\n    height: 28px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: var(--font-weight-title);\n    color: var(--sondage-text-title);\n}\n\n.sondage_column_body {\n    padding: 0 14px 14px;\n    overflow-y: auto;\n    max-height: 70vh;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.sondage_empty {\n    text-align: center;\n    padding: 40px 16px;\n    color: var(--gris-tertiaire-2);\n    font-size: 14px;\n}\n\n.sondage_empty i {\n    font-size: 28px;\n    display: block;\n    margin-bottom: 8px;\n    color: var(--gris-principale);\n}\n\n.sondage_empty_inline {\n    font-size: 13px;\n    color: var(--gris-tertiaire-2);\n    font-style: italic;\n    margin: 4px 0 12px;\n}\n\n/* ============================================================\n   CARTE\n   ============================================================ */\n\n.sondage_card {\n    background: var(--sondage-card-bg);\n    border: 1px solid var(--sondage-card-border);\n    border-radius: 12px;\n    padding: 12px 14px;\n    box-shadow: 0 1px 2px var(--sondage-card-shadow);\n    cursor: pointer;\n    transition: border-color 0.15s ease, transform 0.15s ease;\n}\n\n.sondage_card:hover {\n    border-color: var(--sondage-card-hover-border);\n    transform: translateY(-1px);\n}\n\n.sondage_card_top {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.sondage_avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: var(--sondage-avatar-bg);\n    color: var(--white-principale);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: var(--font-weight-title);\n    font-size: 14px;\n    flex-shrink: 0;\n    overflow: hidden;\n}\n\n.sondage_avatar_done {\n    background: var(--sondage-avatar-done-bg);\n}\n\n.sondage_avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.sondage_avatar span {\n    color: var(--white-principale);\n    margin-left: 0;\n}\n\n.sondage_card_identity {\n    min-width: 0;\n}\n\n.sondage_card_name {\n    font-size: var(--font-size-article-title);\n    font-weight: var(--font-weight-title);\n    color: var(--sondage-text-title);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.sondage_card_meta {\n    font-size: var(--font-size-location);\n    color: var(--gris-tertiaire-2);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.sondage_card_badges {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 10px;\n}\n\n.sondage_badge {\n    font-size: var(--font-size-badge);\n    padding: 3px 9px;\n    border-radius: 999px;\n    display: inline-flex;\n    align-items: center;\n    font-weight: var(--font-weight-medium);\n}\n\n.sondage_badge_vendeur {\n    background: var(--sondage-badge-vendeur-bg);\n    color: var(--sondage-badge-vendeur-fg);\n}\n\n.sondage_badge_article {\n    background: var(--sondage-badge-article-bg);\n    color: var(--sondage-badge-article-fg);\n}\n\n.sondage_badge_done {\n    background: var(--sondage-badge-done-bg);\n    color: var(--sondage-badge-done-fg);\n}\n\n.sondage_card_footer {\n    margin-top: 10px;\n    font-size: 12px;\n    color: var(--gris-tertiaire-2);\n    display: flex;\n    align-items: center;\n}\n\n/* ============================================================\n   MODAL (ancien overlay — conservé si utilisé ailleurs)\n   ============================================================ */\n\n.sondage_modal_overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 16px;\n    z-index: 1050;\n}\n\n.sondage_modal {\n    background: var(--white-principale);\n    border-radius: 14px;\n    width: 100%;\n    max-width: 640px;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.sondage_modal_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid var(--gris-secondaire-3);\n}\n\n.sondage_modal_name {\n    font-size: var(--font-size-detail-section);\n    font-weight: var(--font-weight-title);\n    color: var(--sondage-text-title);\n}\n\n.sondage_modal_close {\n    background: none;\n    border: none;\n    font-size: 18px;\n    color: var(--gris-tertiaire-2);\n    cursor: pointer;\n}\n\n.sondage_modal_body {\n    padding: 18px 20px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.sondage_modal_footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    padding: 14px 20px;\n    border-top: 1px solid var(--gris-secondaire-3);\n}\n\n/* ============================================================\n   SECTIONS / QUESTIONS-REPONSES (ancien layout — conservé)\n   ============================================================ */\n\n.sondage_section {\n    margin-bottom: 20px;\n}\n\n.sondage_section_title {\n    font-size: var(--font-size-detail-section);\n    font-weight: var(--font-weight-title);\n    color: var(--sondage-text-title);\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n}\n\n.sondage_qa {\n    padding: 8px 0;\n    border-bottom: 1px dashed var(--gris-secondaire-3);\n}\n\n.sondage_qa:last-child {\n    border-bottom: none;\n}\n\n.sondage_qa_question {\n    font-size: 13px;\n    color: var(--gris-tertiaire-2);\n    margin-bottom: 2px;\n}\n\n.sondage_qa_reponse {\n    font-size: var(--font-size-detail-text);\n    color: var(--sondage-text-title);\n    font-weight: var(--font-weight-medium);\n}\n\n.sondage_form_group {\n    margin-bottom: 14px;\n}\n\n.sondage_form_label {\n    font-size: 13px;\n    font-weight: var(--font-weight-medium);\n    color: var(--sondage-text-title);\n    margin-bottom: 6px;\n}\n\n.sondage_article_block {\n    border: 1px solid var(--gris-secondaire-3);\n    border-radius: 10px;\n    padding: 10px 14px;\n    margin-bottom: 12px;\n    background: var(--gris-foncer);\n}\n\n.sondage_article_block_todo {\n    border-color: var(--kpi-signal-fg);\n    background: var(--kpi-signal-bg);\n}\n\n.sondage_article_summary {\n    font-size: var(--font-size-article-title);\n    font-weight: var(--font-weight-title);\n    color: var(--sondage-text-title);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.sondage_article_block[open] .sondage_article_summary {\n    margin-bottom: 10px;\n}\n\n/* ============================================================\n   VARIABLES DEDIEES (dérivées de la palette principale)\n   ============================================================ */\n\n:root {\n    --sondage-accent: var(--couleur-principale);\n    --sondage-accent-soft: rgba(11, 0, 207, 0.06);\n    --sondage-accent-soft-strong: rgba(11, 0, 207, 0.1);\n\n    --sondage-attention: var(--couleur-secondaire);\n    --sondage-attention-soft: rgba(255, 45, 43, 0.06);\n    --sondage-attention-soft-strong: rgba(255, 45, 43, 0.1);\n\n    --sondage-success: var(--vert-principale);\n    --sondage-success-soft: rgba(37, 183, 154, 0.08);\n    --sondage-success-soft-strong: rgba(37, 183, 154, 0.14);\n\n    /* --- NOUVEAU : bouton fermer, progression, scrollbar --- */\n    --sondage-close-bg: var(--white-principale);\n    --sondage-close-bg-hover: var(--gris-secondaire-2);\n    --sondage-close-fg: var(--sondage-text-title);\n\n    --sondage-progress-track: rgba(255, 255, 255, 0.18);\n    --sondage-progress-fill: var(--white-principale);\n\n    --sondage-scrollbar-thumb: var(--gris-secondaire-3);\n    --sondage-scrollbar-thumb-hover: var(--gris-principale);\n    --sondage-scrollbar-track: transparent;\n}\n\n/* ============================================================\n   STRUCTURE PLEIN ECRAN\n   ============================================================ */\n\n.sondage_modal_fullscreen {\n    position: fixed;\n    inset: 0;\n    z-index: 1055;\n    display: flex;\n    background: var(--white-principale);\n    animation: sondageModalIn 0.18s ease-out;\n}\n\n@keyframes sondageModalIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n/* ---- Bouton fermer (X) — toujours visible, desktop + mobile ---- */\n\n.sondage_modal_close_x {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    z-index: 20;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    border: none;\n    background: var(--sondage-close-bg);\n    color: var(--sondage-close-fg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    cursor: pointer;\n    box-shadow: 0 2px 10px var(--gris-shadow);\n    transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.sondage_modal_close_x:hover {\n    background: var(--sondage-close-bg-hover);\n    transform: scale(1.06);\n}\n\n.sondage_modal_close_x:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* ---- Sidebar ---- */\n\n.sondage_modal_sidebar {\n    width: 300px;\n    flex-shrink: 0;\n    background: linear-gradient(165deg,\n            var(--couleur-principale) 0%,\n            var(--violet-principale) 130%);\n    color: var(--white-principale);\n    display: flex;\n    flex-direction: column;\n    padding: 32px 22px 22px;\n    overflow-y: auto;\n}\n\n.sondage_sidebar_user {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding-bottom: 24px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.18);\n}\n\n.sondage_avatar_xl {\n    width: 76px;\n    height: 76px;\n    font-size: 24px;\n    background: rgba(255, 255, 255, 0.15);\n    border: 2px solid rgba(255, 255, 255, 0.4);\n    margin-bottom: 14px;\n}\n\n.sondage_sidebar_name {\n    font-size: 17px;\n    font-weight: var(--font-weight-title);\n}\n\n.sondage_sidebar_email {\n    font-size: 12.5px;\n    color: rgba(255, 255, 255, 0.75);\n    margin-top: 2px;\n    word-break: break-word;\n}\n\n.sondage_sidebar_phone {\n    font-size: 15px;\n    color: var(--white-principale);\n    margin-top: 2px;\n    word-break: break-word;\n}\n\n.sondage_sidebar_remaining {\n    margin-top: 14px;\n    background: rgba(255, 255, 255, 0.16);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 999px;\n    padding: 5px 14px;\n    font-size: 12px;\n    font-weight: var(--font-weight-medium);\n    color: var(--white-principale);\n}\n\n/* ---- Barre de progression ---- */\n\n.sondage_sidebar_progress_track {\n    width: 100%;\n    height: 6px;\n    border-radius: 999px;\n    background: var(--sondage-progress-track);\n    margin-top: 14px;\n    overflow: hidden;\n}\n\n.sondage_sidebar_progress_fill {\n    height: 100%;\n    border-radius: 999px;\n    background: var(--sondage-progress-fill);\n    transition: width 0.25s ease;\n}\n\n.sondage_sidebar_progress_label {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.75);\n    margin-top: 6px;\n}\n\n.sondage_sidebar_steps {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n    margin-top: 20px;\n}\n\n.sondage_step {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 12px;\n    border-radius: 10px;\n    color: rgba(255, 255, 255, 0.85);\n    text-decoration: none;\n    font-size: 13.5px;\n    font-weight: var(--font-weight-medium);\n    transition: background 0.15s ease;\n}\n\n.sondage_step:hover {\n    background: rgba(255, 255, 255, 0.12);\n    color: var(--white-principale);\n}\n\n.sondage_step_label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: var(--white-principale);\n}\n\n.sondage_step_dot {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 2px solid rgba(255, 255, 255, 0.55);\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n}\n\n/* .sondage_step_dot i {\n  color: #fff;\n} */\n\n.sondage_step_done .sondage_step_dot {\n    background: var(--white-principale);\n    color: var(--sondage-accent);\n    border-color: var(--white-principale);\n}\n\n.sondage_step_todo .sondage_step_dot {\n    border-color: var(--white-principale);\n}\n\n.sondage_sidebar_close {\n    margin-top: 20px;\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.35);\n    color: var(--white-principale);\n    border-radius: 10px;\n    padding: 10px 14px;\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background 0.15s ease;\n}\n\n.sondage_sidebar_close:hover {\n    background: rgba(255, 255, 255, 0.14);\n}\n\n.sondage_sidebar_close:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* ---- Zone principale ---- */\n/* FIX SCROLL : min-height:0 est obligatoire sur les enfants flex\n   dont on veut que overflow-y:auto fonctionne réellement */\n\n.sondage_modal_main {\n    flex: 1;\n    min-width: 0;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    background: var(--gris-foncer);\n    padding-bottom: 50px;\n}\n\n.sondage_modal_content {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    display: flex;\n    justify-content: center;\n    padding: 40px 24px 48px;\n}\n\n/* Scrollbar stylée (Chrome / Edge / Safari) */\n.sondage_modal_content::-webkit-scrollbar,\n.sondage_modal_sidebar::-webkit-scrollbar {\n    width: 8px;\n}\n\n.sondage_modal_content::-webkit-scrollbar-track,\n.sondage_modal_sidebar::-webkit-scrollbar-track {\n    background: var(--sondage-scrollbar-track);\n}\n\n.sondage_modal_content::-webkit-scrollbar-thumb {\n    background: var(--sondage-scrollbar-thumb);\n    border-radius: 999px;\n}\n\n.sondage_modal_content::-webkit-scrollbar-thumb:hover {\n    background: var(--sondage-scrollbar-thumb-hover);\n}\n\n.sondage_modal_sidebar::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.3);\n    border-radius: 999px;\n}\n\n.sondage_modal_sections {\n    width: 90%;\n    /* max-width: 720px; */\n    display: flex;\n    flex-direction: column;\n    gap: 22px;\n    scroll-behavior: smooth;\n}\n\n/* ============================================================\n   CARTES DE FORMULAIRE\n   ============================================================ */\n\n.sondage_form_card {\n    background: var(--white-principale);\n    border-radius: 16px;\n    border: 1px solid var(--gris-secondaire-3);\n    box-shadow: 0 2px 10px var(--gris-shadow);\n    scroll-margin-top: 24px;\n    /* overflow: hidden; */\n}\n\n.sondage_form_card_header {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 18px 22px;\n}\n\n.sondage_form_card_header i {\n    font-size: 20px;\n    width: 42px;\n    height: 42px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.sondage_form_card_header h6 {\n    margin: 0;\n    font-size: 15.5px;\n    font-weight: var(--font-weight-title);\n    color: var(--sondage-text-title);\n}\n\n.sondage_form_card_header span {\n    font-size: 12.5px;\n    color: var(--gris-tertiaire-2);\n}\n\n.sondage_form_card_todo .sondage_form_card_header {\n    background: var(--sondage-attention-soft);\n}\n\n.sondage_form_card_todo .sondage_form_card_header i {\n    background: var(--sondage-attention-soft-strong);\n    color: var(--sondage-attention);\n}\n\n.sondage_form_card_done .sondage_form_card_header {\n    background: var(--sondage-success-soft);\n}\n\n.sondage_form_card_done .sondage_form_card_header i {\n    background: var(--sondage-success-soft-strong);\n    color: var(--sondage-success);\n}\n\n.sondage_form_card_body {\n    padding: 20px 22px 22px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n/* ============================================================\n   CHAMPS\n   ============================================================ */\n\n.sondage_field {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.sondage_field_label {\n    font-size: 13.5px;\n    font-weight: var(--font-weight-medium);\n    color: var(--sondage-text-title);\n}\n\n.sondage_field_input {\n    width: 100%;\n    border: 1.5px solid var(--gris-secondaire-3);\n    border-radius: 10px;\n    padding: 11px 14px;\n    font-size: 14px;\n    font-family: inherit;\n    resize: vertical;\n    background: var(--white-tertiaire-1);\n    transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.sondage_field_input:focus {\n    outline: none;\n    border-color: var(--sondage-accent);\n    background: var(--white-principale);\n    box-shadow: 0 0 0 3px var(--sondage-accent-soft);\n}\n\n.sondage_field_readonly .sondage_field_label {\n    color: var(--gris-tertiaire-2);\n    font-weight: var(--font-weight-normal);\n}\n\n.sondage_field_value {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    border: 1.5px solid var(--sondage-success-soft-strong);\n    background: var(--sondage-success-soft);\n    border-radius: 10px;\n    padding: 11px 14px;\n    font-size: 14px;\n    font-weight: var(--font-weight-medium);\n    color: var(--sondage-text-title);\n}\n\n.sondage_field_value i {\n    color: var(--sondage-success);\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n/* ---- Choix à puces (pills) ---- */\n\n.sondage_pill_group {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.sondage_pill {\n    border: 1.5px solid var(--gris-secondaire-3);\n    background: var(--white-principale);\n    color: var(--sondage-text-title);\n    border-radius: 999px;\n    padding: 8px 16px;\n    font-size: 13px;\n    font-weight: var(--font-weight-medium);\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.sondage_pill:hover {\n    border-color: var(--sondage-accent);\n}\n\n.sondage_pill.active {\n    background: var(--sondage-accent);\n    border-color: var(--sondage-accent);\n    color: var(--white-principale);\n}\n\n.sondage_empty_inline {\n    font-size: 13px;\n    color: var(--gris-tertiaire-2);\n    font-style: italic;\n    margin: 0;\n}\n\n/* ============================================================\n   FOOTER\n   ============================================================ */\n\n.sondage_modal_footer_fixed {\n    position: sticky;\n    bottom: 0;\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    padding: 16px 24px;\n    background: var(--white-principale);\n    border-top: 1px solid var(--gris-secondaire-3);\n    flex-shrink: 0;\n}\n\n.sondage_btn_secondary {\n    background: var(--white-principale);\n    border: 1.5px solid var(--gris-secondaire-3);\n    color: var(--sondage-text-title);\n    border-radius: 10px;\n    padding: 9px 18px;\n    font-size: var(--font-size-btn);\n}\n\n.sondage_btn_primary {\n    background: linear-gradient(120deg,\n            var(--couleur-principale),\n            var(--violet-principale));\n    color: var(--white-principale);\n    border: none;\n    border-radius: 10px;\n    padding: 9px 20px;\n    font-size: var(--font-size-btn);\n    font-weight: var(--font-weight-medium);\n    box-shadow: 0 4px 14px var(--sondage-accent-soft-strong);\n}\n\n.sondage_btn_primary:disabled,\n.sondage_btn_secondary:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n/* ---- Item sidebar \"Tout afficher\" + état actif ---- */\n\n.sondage_step_all {\n    font-weight: var(--font-weight-title);\n    margin-bottom: 8px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.14);\n    padding-bottom: 12px;\n}\n\n.sondage_step.active {\n    background: rgba(255, 255, 255, 0.22);\n    color: var(--white-principale);\n}\n\n/* ---- Footer de section (bouton individuel) ---- */\n\n.sondage_form_card_footer {\n    display: flex;\n    justify-content: flex-end;\n    padding: 4px 22px 22px;\n}\n\n.sondage_btn_primary_sm {\n    background: var(--sondage-accent);\n    color: var(--white-principale);\n    border: none;\n    border-radius: 8px;\n    padding: 8px 16px;\n    font-size: 13px;\n    font-weight: var(--font-weight-medium);\n    cursor: pointer;\n    transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.sondage_btn_primary_sm:hover:not(:disabled) {\n    transform: translateY(-1px);\n}\n\n.sondage_btn_primary_sm:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* ============================================================\n   REMARQUE\n   ============================================================ */\n\n.sondage_remarque_block {\n    border-top: 1px dashed var(--gris-secondaire-3);\n    padding-top: 16px;\n    margin-top: 4px;\n}\n\n.sondage_remarque_label {\n    font-size: 13.5px;\n    font-weight: var(--font-weight-medium);\n    color: var(--sondage-text-title);\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.sondage_remarque_label i {\n    color: var(--sondage-attention);\n}\n\n.sondage_field_value_remarque {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    border: 1.5px dashed var(--gris-secondaire-3);\n    background: var(--gris-foncer);\n    border-radius: 10px;\n    padding: 11px 14px;\n    font-size: 13.5px;\n    color: var(--gris-tertiaire-2);\n    font-style: italic;\n}\n\n.sondage_field_value_remarque i {\n    color: var(--sondage-attention);\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n/* ============================================================\n   QUESTIONS IMPREVUES\n   ============================================================ */\n\n.sondage_extra_questions {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    margin-top: 4px;\n}\n\n.sondage_extra_question {\n    border: 1.5px dashed var(--sondage-accent-soft-strong);\n    background: var(--sondage-accent-soft);\n    border-radius: 10px;\n    padding: 12px 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.sondage_extra_question_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n}\n\n.sondage_extra_question_tag {\n    font-size: 11px;\n    font-weight: var(--font-weight-medium);\n    color: var(--sondage-accent);\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.sondage_extra_remove_btn {\n    background: none;\n    border: none;\n    color: var(--sondage-attention);\n    font-size: 15px;\n    cursor: pointer;\n    padding: 2px 6px;\n    border-radius: 6px;\n    line-height: 1;\n    transition: background 0.15s ease;\n}\n\n.sondage_extra_remove_btn:hover {\n    background: var(--sondage-attention-soft-strong);\n}\n\n.sondage_extra_question_input {\n    border: 1.5px solid var(--gris-secondaire-3);\n    border-radius: 8px;\n    padding: 9px 12px;\n    font-size: 13.5px;\n    font-family: inherit;\n    background: var(--white-principale);\n    transition: border-color 0.15s ease;\n}\n\n.sondage_extra_question_input:focus {\n    outline: none;\n    border-color: var(--sondage-accent);\n    box-shadow: 0 0 0 3px var(--sondage-accent-soft);\n}\n\n.sondage_btn_add_question {\n    align-self: flex-start;\n    background: transparent;\n    border: 1.5px dashed var(--gris-secondaire-3);\n    color: var(--sondage-accent);\n    border-radius: 8px;\n    padding: 8px 14px;\n    font-size: 13px;\n    font-weight: var(--font-weight-medium);\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.sondage_btn_add_question:hover {\n    border-color: var(--sondage-accent);\n    background: var(--sondage-accent-soft);\n}\n\n@media (max-width: 575px) {\n    .sondage_form_card_footer {\n        padding: 4px 16px 16px;\n    }\n}\n\n.sondage_btn_export {\n    background: var(--sondage-badge-done-bg);\n    color: var(--sondage-badge-done-fg);\n    border: 1px solid var(--sondage-col-done-border);\n    border-radius: 8px;\n    font-size: var(--font-size-btn);\n    padding: 8px 14px;\n    font-weight: var(--font-weight-medium);\n    transition: background 0.15s ease;\n}\n\n.sondage_btn_export:hover:not(:disabled) {\n    background: var(--sondage-success-soft-strong);\n}\n\n.sondage_btn_export:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* ============================================================\n   RECHERCHE\n   ============================================================ */\n\n.sondage_search_wrap {\n    margin-top: 16px;\n}\n\n.sondage_search_box {\n    position: relative;\n    max-width: 420px;\n    display: flex;\n    align-items: center;\n}\n\n.sondage_search_icon {\n    position: absolute;\n    left: 14px;\n    color: var(--gris-tertiaire-2);\n    font-size: 14px;\n    pointer-events: none;\n}\n\n.sondage_search_input {\n    width: 100%;\n    border: 1.5px solid var(--gris-secondaire-3);\n    border-radius: 10px;\n    padding: 10px 40px 10px 38px;\n    font-size: 14px;\n    font-family: inherit;\n    background: var(--white-principale);\n    color: var(--sondage-text-title);\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.sondage_search_input:focus {\n    outline: none;\n    border-color: var(--sondage-accent);\n    box-shadow: 0 0 0 3px var(--sondage-accent-soft);\n}\n\n.sondage_search_input::placeholder {\n    color: var(--gris-tertiaire-2);\n}\n\n.sondage_search_clear {\n    position: absolute;\n    right: 10px;\n    background: none;\n    border: none;\n    color: var(--gris-tertiaire-2);\n    font-size: 12px;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 50%;\n    transition: background 0.15s ease;\n}\n\n.sondage_search_clear:hover {\n    background: var(--gris-secondaire-2);\n    color: var(--sondage-text-title);\n}\n\n/* ============================================================\n   SELECTION GROUPEE (bulk)\n   ============================================================ */\n\n.sondage_step_bulk_toggle {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px dashed rgba(255, 255, 255, 0.4);\n    cursor: pointer;\n    width: 100%;\n    text-align: left;\n    margin-bottom: 2px;\n    font-family: inherit;\n}\n\n.sondage_step_bulk_toggle:hover {\n    background: rgba(255, 255, 255, 0.16);\n}\n\n.sondage_step_bulk_toggle.active {\n    background: rgba(255, 255, 255, 0.22);\n    border-style: solid;\n}\n\n.sondage_bulk_select_all {\n    background: none;\n    border: none;\n    color: rgba(255, 255, 255, 0.85);\n    font-size: 12px;\n    text-decoration: underline;\n    padding: 2px 12px 12px;\n    cursor: pointer;\n    align-self: flex-start;\n}\n\n.sondage_bulk_select_all:hover {\n    color: var(--white-principale);\n}\n\n.sondage_step_checkable {\n    cursor: pointer;\n}\n\n.sondage_step_checkbox {\n    width: 16px;\n    height: 16px;\n    accent-color: var(--white-principale);\n    flex-shrink: 0;\n    cursor: pointer;\n    margin: 0;\n}\n\n.sondage_step_checkable.checked {\n    background: rgba(255, 255, 255, 0.18);\n}\n\n.sondage_bulk_bar {\n    position: sticky;\n    top: 0;\n    z-index: 5;\n    background: var(--white-principale);\n    border: 1.5px solid var(--sondage-accent);\n    border-radius: 16px;\n    box-shadow: 0 4px 18px var(--sondage-card-shadow);\n    padding: 18px 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.sondage_bulk_bar_title {\n    font-size: 13.5px;\n    font-weight: var(--font-weight-title);\n    color: var(--sondage-accent);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.sondage_step_done .sondage_step_dot {\n    background: var(--sondage-success);\n    color: var(--white-principale);\n    border-color: var(--sondage-success);\n}\n\n.sondage_step_done .sondage_step_dot i {\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.sondage_step_todo .sondage_step_dot {\n    background: transparent;\n    border-color: rgba(255, 255, 255, 0.5);\n}\n\n/* Léger contraste de fond pour bien distinguer les lignes \"faites\" */\n.sondage_step_done {\n    color: rgba(255, 255, 255, 0.95);\n}\n\n.sondage_step_done .sondage_step_label {\n    opacity: 0.9;\n}\n\n.sondage_sidebar_legend {\n    display: flex;\n    gap: 14px;\n    font-size: 11.5px;\n    color: rgba(255, 255, 255, 0.75);\n    margin-top: 8px;\n}\n\n.sondage_sidebar_legend span {\n    color: var(--white-principale);\n}\n\n.sondage_legend_dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    margin-right: 5px;\n}\n\n.sondage_legend_dot.done {\n    background: var(--sondage-success);\n}\n\n.sondage_legend_dot.todo {\n    border: 1.5px solid rgba(255, 255, 255, 0.6);\n}\n\n@media (max-width: 900px) {\n    .sondage_step_checkable {\n        flex-shrink: 0;\n    }\n}\n\n@media (max-width: 575px) {\n    .sondage_search_box {\n        max-width: 100%;\n    }\n}\n\n\n/* ============================================================\n   HEADER — positionnement pour bouton Modifier\n   ============================================================ */\n.sondage_form_card_header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.sondage_form_card_header>div:not(.sondage_edit_actions) {\n    flex: 1;\n}\n\n/* ============================================================\n   BOUTON MODIFIER\n   ============================================================ */\n.sondage_btn_edit {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 6px 12px;\n    font-size: 0.82rem;\n    font-weight: 500;\n    color: #0B00CF;\n    background-color: transparent;\n    border: none;\n    /* border-radius: 8px; */\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background-color 0.15s ease, transform 0.1s ease;\n}\n\n.sondage_btn_edit:hover {\n    background-color: #E4E1FF;\n}\n\n.sondage_btn_edit:active {\n    transform: scale(0.97);\n}\n\n.sondage_btn_edit i {\n    font-size: 0.78rem;\n}\n\n/* ============================================================\n   ACTIONS EN MODE EDITION (Enregistrer / Annuler)\n   ============================================================ */\n.sondage_edit_actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.sondage_btn_secondary_sm {\n    padding: 6px 14px;\n    font-size: 0.82rem;\n    font-weight: 500;\n    color: #555;\n    background-color: #F2F2F2;\n    border: 1px solid #DDD;\n    border-radius: 8px;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background-color 0.15s ease;\n}\n\n.sondage_btn_secondary_sm:hover:not(:disabled) {\n    background-color: #E6E6E6;\n}\n\n.sondage_btn_secondary_sm:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* ============================================================\n   TOGGLE MOBILE — bascule entre les 2 colonnes (façon light/dark)\n   ============================================================ */\n\n.sondage_mobile_switch {\n    display: none;\n}\n\n@media (max-width: 991px) {\n    .sondage_mobile_switch {\n        display: flex;\n        align-items: center;\n        gap: 2px;\n        margin-top: 14px;\n        padding: 4px;\n        background: var(--gris-foncer);\n        border: 1px solid var(--gris-secondaire-3);\n        border-radius: 999px;\n        max-width: 420px;\n        margin-bottom: 10px;\n    }\n\n    .sondage_mobile_switch_btn {\n        flex: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        border: none;\n        background: transparent;\n        color: var(--gris-tertiaire-2);\n        font-size: 13px;\n        font-weight: var(--font-weight-medium);\n        padding: 9px 10px;\n        border-radius: 999px;\n        cursor: pointer;\n        transition: background 0.18s ease, color 0.18s ease;\n    }\n\n    .sondage_mobile_switch_btn.active {\n        background: var(--sondage-accent);\n        color: var(--white-principale);\n        box-shadow: 0 2px 8px var(--sondage-accent-soft-strong);\n    }\n\n    .sondage_mobile_switch_count {\n        font-size: 11px;\n        font-weight: 700;\n        background: rgba(255, 255, 255, 0.25);\n        border-radius: 999px;\n        min-width: 18px;\n        padding: 1px 6px;\n        line-height: 1.4;\n    }\n\n    .sondage_mobile_switch_btn:not(.active) .sondage_mobile_switch_count {\n        background: var(--white-principale);\n        color: var(--sondage-text-title);\n        border: 1px solid var(--gris-secondaire-3);\n    }\n\n    .sondage_col_hide_mobile {\n        display: none !important;\n    }\n}\n\n\n@media (max-width: 576px) {\n    .sondage_form_card_header {\n        flex-wrap: wrap;\n    }\n\n    .sondage_btn_edit,\n    .sondage_edit_actions {\n        margin-left: auto;\n    }\n}\n\n/* ============================================================\n   RESPONSIVE\n   ============================================================ */\n\n@media (max-width: 900px) {\n    .sondage_modal_fullscreen {\n        flex-direction: column;\n    }\n\n    .sondage_modal_sidebar {\n        width: 100%;\n        flex-direction: row;\n        align-items: center;\n        padding: 16px 60px 16px 18px;\n        /* espace réservé au bouton X */\n        gap: 16px;\n        overflow-x: auto;\n        overflow-y: visible;\n        flex-shrink: 0;\n    }\n\n    .sondage_sidebar_user {\n        flex-direction: row;\n        text-align: left;\n        border-bottom: none;\n        border-right: 1px solid rgba(255, 255, 255, 0.18);\n        padding-bottom: 0;\n        margin-bottom: 0;\n        padding-right: 16px;\n        gap: 12px;\n        flex-shrink: 0;\n    }\n\n    .sondage_avatar_xl {\n        width: 48px;\n        height: 48px;\n        font-size: 16px;\n        margin-bottom: 0;\n    }\n\n    .sondage_sidebar_progress_track,\n    .sondage_sidebar_progress_label {\n        display: none;\n    }\n\n    .sondage_sidebar_remaining {\n        margin-top: 4px;\n    }\n\n    .sondage_sidebar_steps {\n        flex-direction: row;\n        overflow-x: auto;\n        margin-top: 0;\n    }\n\n    .sondage_step_label {\n        max-width: 110px;\n    }\n\n    .sondage_sidebar_close {\n        display: none;\n    }\n\n    .sondage_modal_content {\n        padding: 24px 16px 32px;\n    }\n}\n\n@media (max-width: 575px) {\n    .sondage_page {\n        padding: 16px 10px 32px;\n    }\n\n    .sondage_modal {\n        max-height: 95vh;\n    }\n\n    .sondage_card_name {\n        max-width: 160px;\n    }\n\n    .sondage_form_card_header {\n        padding: 14px 16px;\n    }\n\n    .sondage_form_card_body {\n        padding: 16px;\n    }\n\n    .sondage_modal_footer_fixed {\n        padding: 12px 16px;\n    }\n\n    .sondage_modal_close_x {\n        top: 12px;\n        right: 12px;\n        width: 34px;\n        height: 34px;\n    }\n}\n\n@media (max-width: 991px) {\n    .sondage_column_body {\n        max-height: 70vh;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
